import { useQuery } from '@tanstack/react-query';

import { useAuthentication } from '../../Idp/useAuthentication';
import { useCoreApi } from '../api';
import { coreKeys } from '../query-key-factory';
import { IListUserCauseSelectionsResponse } from './types';

const useListUserCauseSelections = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const CoreApi = useCoreApi();
  const { isAuthenticated } = useAuthentication();

  const getUserAccounts = async () => {
    const { data } = await CoreApi.get<IListUserCauseSelectionsResponse>('/cause_selections');
    return data.cause_selections;
  };

  return useQuery({
    queryKey: coreKeys.user.causeSelection.all,
    queryFn: getUserAccounts,
    enabled: isAuthenticated && enabled,
  });
};

export { useListUserCauseSelections };
